import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { doChangeChannelRoute } from '../store/actions/channels';
import { selectCurrentChannelId, selectChannels } from '../store/selectors';
import { ClusterApi } from "@cluster/web-components";
import { selectAlertsPerChannel } from '../store/selectors/alerts';
import { ReactComponent as ClusterTypeIcon } from '../images/channelTypeCluster.svg'
import { BsNewspaper as ColumnsTypeIcon } from 'react-icons/bs'

import styles from './ChannelList.module.scss'

export default function ChannelList() {

  const channelList = useSelector(selectChannels);
  const currentChannel = useSelector(selectCurrentChannelId);
  const alertsPerChannel = useSelector(selectAlertsPerChannel);

  let channels = [];

  for(const channel of channelList??{}) {
    const channelAlerts = alertsPerChannel.find(channelAlerts => channelAlerts.channel === channel.id)?.alerts;
    channels.push(<ChannelListItem
                    key={channel.id}
                    id={channel.id}
                    title={channel.name}
                    description={channel.description}
                    active={channel.id === currentChannel}
                    alerts={channelAlerts}
                    layoutType={channel.defaultLayoutConfig?.type??'grid'}
                  />);
  }
  return (
    <div className={styles.list}>
      { channels }
    </div>
  )
}

type ChannelListItemProps = {
  id: number,
  title: string,
  description?: string
  active: boolean,
  alerts?: ClusterApi.BoardAlert[],
  layoutType: ClusterApi.LayoutConfig['type']
}

const ChannelListItem = function(props: ChannelListItemProps) {
  const dispatch = useDispatch();

  return (
    <div className={props.active ? styles.activeItem : styles.item} onClick={(e: React.MouseEvent) => dispatch(doChangeChannelRoute(props.id))}>
      { ((props.alerts?.length??0) > 0) ? <div className={styles.badge}> { props.alerts!.length } </div> : undefined }
      { props.layoutType === "columns" ? <ColumnsTypeIcon className={styles.icon} /> : <ClusterTypeIcon className={styles.icon} />}
      <div className={styles.itemTitle}>{ props.title }</div>
      <div className={styles.itemDesc}>{ props.description }</div>
    </div>
  )
}